import React, { Component, PropTypes } from 'react';

/**
 * Callout displayed if user's email hasn't been validated yet,
 * allowing for validation email re-submission.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const EmailNotValidated = ({user, resendValidationEmail}) => {
  /* email was already validated */
  if (user.profile_data.is_email_validated) return null

  return (
    <div className="callout primary">
      <h3>{user.validationEmailResent? "Email Sent":"Please Verify Your Email"}</h3>
      <p>
        {user.validationEmailResent?
        "We've just sent you a validation email. Please check your inbox.":
        <span>
          We sent a verification email to the address you provided. If you received it, please
          click on the link in email to verify your account. If you didn&apos;t receive it,
          check your spam inbox or we&apos;ll gladly <a onClick={resendValidationEmail}>resend it</a>.
        </span>}
      </p>
    </div>
  )
}

/**
 * PropTypes.
 *
 * @property {object} user - logged in user
 * @property {func} resendValidationEmail - re-send email validation email
 */
EmailNotValidated.propTypes = {
  user: PropTypes.object,
  resendValidationEmail: PropTypes.func
};

export default EmailNotValidated;



// WEBPACK FOOTER //
// ./account/components/email_not_validated.jsx